import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { CollapseType } from '@meitu/saas-editor-ui';

export interface IWatermarkCollapseModel {
    /**
     * 来源信息
     */
    from: CollapseType | null;

    /**
     * 设置来源信息
     */
    setFrom: (payload: CollapseType | null) => void;

    /**
     * 是否显示二级返回标题（进入专题列表需要展示二级返回标题）
     */
    showSubBackTitle: boolean;

    /**
     * 设置是否显示二级返回标题
     */
    setShowSubBackTitle: (payload: boolean) => void;
}

const useWatermarkCollapseModel = create<IWatermarkCollapseModel>()(
    immer((set) => ({
        from: null,

        setFrom: (payload) =>
            set((state) => {
                state.from = payload;
            }),

        showSubBackTitle: false,

        setShowSubBackTitle: (payload) =>
            set((state) => {
                state.showSubBackTitle = payload;
            }),
    })),
);

export { useWatermarkCollapseModel };
export const getWatermarkCollapseModel = () => useWatermarkCollapseModel.getState();
